import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input, Modal, Tag, Alert, Row, Col } from 'mkui-fd';
import classNames from 'classnames';

const btns = [
  { code: '+', name: '+', isOperator: true },
  { code: 7, name: 7, isOperator: false },
  { code: 8, name: 8, isOperator: false },
  { code: 9, name: 9, isOperator: false },
  { code: 'C', name: 'C', isOperator: true },
  { code: '-', name: '-', isOperator: true },
  { code: 4, name: 4, isOperator: false },
  { code: 5, name: 5, isOperator: false },
  { code: 6, name: 6, isOperator: false },
  { code: '=', name: '=', isOperator: true },
  { code: '*', name: '*', isOperator: true },
  { code: 1, name: 1, isOperator: false },
  { code: 2, name: 2, isOperator: false },
  { code: 3, name: 3, isOperator: false },
  { code: '%', name: '%', isOperator: true },
  { code: '/', name: '/', isOperator: true },
  { code: '00', name: '00', isOperator: false },
  { code: 0, name: 0, isOperator: false },
  { code: '.', name: '.', isOperator: false },
  { code: 'D', name: 'D', isOperator: true },
];

const ExpressionBuilder = ({ prefixCls, dataSource }) => {

  const [visible, setVisible] = useState(false);
  const [store, setStore] = useState(dataSource)
  const [formulaQueue, setFormulaQueue] = useState([]);

  const selectedHandle = item => {
    setStore(store => store.filter(s => s.code !== item.code))
    pushFormulaQueue(item)
  }

  const pushFormulaQueue = item => {
    setFormulaQueue(formula => [...formula, item])
  }

  const clearHandle = item => {
    setFormulaQueue(formula => formula.filter(s => s.code !== item.code))
    setStore(store => [...store, item])
  }

  const transformFormula = queue => {
    let result = '';
    queue.forEach(element => {
      result += element.name
    });
    return result
  }
  

  return (
    <React.Fragment>
    <Input onClick={() => {setVisible(true)}} value={transformFormula(formulaQueue)} />
    <Modal
      title="公式"
      visible={visible}
      onOk={() => setVisible(false)}
      onCancel={() => setVisible(false)}
      width="600px"
    >
      <Alert
        description="说明：添加计算公式可用于单据内数字或金额的自动计算，例如：在采购单据中添加单价、数量、合计字段，并为”合计“字段添加“计算公式=单价x数量”，当填写单价和数量后，合计字段中会自动填充计算结果。"
        type="info"
      />
      <div className={`${prefixCls}-bar`}>
        <div className={`${prefixCls}-store`} >
           {/* <p>说明：可用于添加计算公式的字段，仅限本张单据内的数字/金额类型的控件</p> */}
          <Card title="计算对象（限数字、金额控件）">
            <div className={`${prefixCls}-store-content`}>
              {store.map(item => <Tag key={item.code} onClick={() => {selectedHandle(item)}}>{item.name}</Tag>)}
            </div>
          </Card>
        </div>

        <div className={`${prefixCls}-cacular`}>
         <Card title="数字键盘">
          <div className={`${prefixCls}-cacular-content`}>
            <div className={`${prefixCls}-options`}>
                {
                  btns.map(btn =>
                    <div
                      key={btn.code}
                      className={classNames('item', {'item-pan': btn.isOperator})}
                      onClick={() => {pushFormulaQueue(btn)}}
                    >
                      {btn.name}
                    </div>)
                }
              </div>
           </div>
         </Card>
        </div>
      </div>
      <div className={`${prefixCls}-formula`} >
        <span>计算公式 = </span>
        {formulaQueue.map(item => {
          if ('isOperator' in item) {
            return item.name
          }
          return <Tag key={item.code}>{item.name}</Tag>
        })}
      </div>
      
    </Modal>
  </React.Fragment>
  )
}


const Card = ({ title, prefixCls = 'coustom-card', cardStyle, children }) => (
  <div className={`${prefixCls}`} style={cardStyle}>
    <div className={`${prefixCls}-title`}>
      {title}      
    </div>
    <div>
      {children}
    </div>
  </div>
)

ExpressionBuilder.propTypes = {
  prefixCls: PropTypes.string,
  dataSource: PropTypes.array,
};

ExpressionBuilder.defaultProps = {
  prefixCls: 'mkui-expression-builder',
  dataSource: [],
};

export default ExpressionBuilder;


